module.exports = __webpack_public_path__ + "static/img/retention.0e09ab27.png";